import React from 'react';
import { Loader, BaasicTable, BaasicConfirmModal, BaasicHeader, BaasicModal } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { SellerEdit3PLCredentials, SellerWarehouse } from 'modules/seller/pages';

const SellerListTemplate = ({
	t,
	viewStore,
	viewStore: { listStore, tableData, queryUtility, activationConfirmModal },
	headerCell,
	actions,
	showActions,
}) => {
	if (viewStore.loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.SELLERS"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					headerCell,
					actions,
					showActions,
				}}
				data={listStore.data.slice()}
			/>
			<BaasicConfirmModal modalParams={activationConfirmModal} />
			<BaasicModal className="ReactModal--lrg" modalParams={viewStore.editSeller3PLCredentialsModal}>
				<SellerEdit3PLCredentials parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--sml-med" modalParams={viewStore.editSellerWarehousesModal}>
				<SellerWarehouse parentViewStore={viewStore} />
			</BaasicModal>
		</section>
	);
};

export default defaultTemplate(SellerListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/seller/pages/SellerListTemplate.jsx